// Form focus/blur handlers
document.addEventListener('focusin', function(e) {
    if (e.target.classList.contains('aa-Input')) {
      const form = e.target.closest('.aa-Form');
      if (form) {
        form.classList.add('active');
      }
    }
});
  
document.addEventListener('focusout', function(e) {
    if (e.target.classList.contains('aa-Input')) {
        const form = e.target.closest('.aa-Form');
        if (form) {
        form.classList.remove('active');
        }
    }
});
  
  // Capture search query when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    function captureSearchQuery() {
        const STORAGE_KEY = 'AUTOCOMPLETE_RECENT_SEARCHES';
        const MAX_RECENT_SEARCHES = 25;

        // Get the current URL
        const url = new URL(window.location.href);

        // Check if we're on a search page and there's a query
        if (url.pathname.includes('/search') && url.searchParams.has('q')) {
        const query = url.searchParams.get('q').trim();

        if (query) {
            // Get existing searches
            let recentSearches = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');

            // Remove this query if it already exists
            recentSearches = recentSearches.filter(item => item.label !== query);

            // Add the new query to the beginning
            recentSearches.unshift({ id: query, label: query });

            // Keep only the last MAX_RECENT_SEARCHES
            recentSearches = recentSearches.slice(0, MAX_RECENT_SEARCHES);

            // Save back to localStorage
            localStorage.setItem(STORAGE_KEY, JSON.stringify(recentSearches));
        }
        }
    }

    // Call the function when the page loads
    captureSearchQuery();
});
  
// Recent searches click handlers
document.addEventListener('DOMContentLoaded', function() {
    const STORAGE_KEY = 'AUTOCOMPLETE_RECENT_SEARCHES';

    // Function to update localStorage
    function updateRecentSearches(searches) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
    }

    // Click handler for recent search items
    document.addEventListener('click', function(e) {
        const recentSearchItem = e.target.closest('.aa-Item[data-autocomplete-source-id="recentSearchesPlugin"]');
        if (recentSearchItem) {
        if (!e.target.closest('.aa-ItemDeleteButton')) {
            const searchTerm = recentSearchItem.querySelector('.aa-ItemContentTitle').textContent.trim();
            const searchInput = document.getElementById('autocomplete-0-input');
            if (searchInput) {
            searchInput.value = searchTerm;
            searchInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        }
    });

    // Click handler for delete buttons
    document.addEventListener('click', function(e) {
        if (e.target.closest('.aa-ItemDeleteButton')) {
        e.stopPropagation();
        const deleteButton = e.target.closest('.aa-ItemDeleteButton');
        const searchId = deleteButton.dataset.searchId;
        let recentSearches = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        recentSearches = recentSearches.filter(search => search.id !== searchId);
        updateRecentSearches(recentSearches);

        // Remove the item from the DOM
        const itemToRemove = deleteButton.closest('.aa-Item');
        if (itemToRemove) {
            itemToRemove.remove();
        }

        // If no more recent searches, remove the entire section
        if (recentSearches.length === 0) {
            const sourceHeaders = document.querySelectorAll('.aa-SourceHeader');
            sourceHeaders.forEach(header => {
            if (header.textContent.includes('Recent Searches')) {
                header.remove();
            }
            });
        }
        }
    });
});
  
  // Click handler for delete recent products
  document.addEventListener('click', function(e) {
    if (e.target.closest('.recent-product-remove')) {
      e.stopPropagation();
      const removeButton = e.target.closest('.recent-product-remove');
      const primaryKey = removeButton.dataset.primaryKey;
      let productViewHistory = JSON.parse(localStorage.getItem('PRODUCT_VIEW_HISTORY') || '[]');
  
      // Find the index to remove based on the primaryKey
      const indexToRemove = productViewHistory.findIndex(item => item.url === primaryKey);
  
      if (indexToRemove !== -1) {
        productViewHistory.splice(indexToRemove, 1);
        localStorage.setItem('PRODUCT_VIEW_HISTORY', JSON.stringify(productViewHistory));
  
        // Remove the item from DOM
        const itemToRemove = document.querySelector(`.aa-Item[data-product-id="${primaryKey}"]`);
        if (itemToRemove) {
          itemToRemove.remove();
        }
      }
    }
  });
  
  // Product view history tracking
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a product page
    if (document.body.classList.contains('product')) {
      const STORAGE_KEY_PRODUCT = 'PRODUCT_VIEW_HISTORY';
      const MAX_PRODUCTS_HISTORY = 5;
  
      // Function to get the cleaned product URL
      function getCleanProductUrl() {
        let url = window.location.pathname;
        url = url.replace(/^.*\/products\//, '/products/');
        url = url.split('?')[0]; // Remove query parameters
        return url;
      }
  
      // Function to get the product title
      function getProductTitle() {
        const visibleElements = document.querySelectorAll('.product__title h1');
        let titleElement = null;
        
        // Get only the first visible element
        for (const element of visibleElements) {
          if (element.offsetParent !== null) { // Check if visible
            titleElement = element;
            break;
          }
        }
        
        if (!titleElement && visibleElements.length > 0) {
          // Fallback to first element if none are visible
          titleElement = visibleElements[0];
        }
        
        return titleElement ? titleElement.textContent.trim() : '';
      }
  
      // Function to get the product image URL
      function getProductImageUrl() {
        const firstImage = document.querySelector('meta[property="og:image"]');
        if (firstImage) {
          const srcset = firstImage.getAttribute('content');
          if (srcset) {
            // Split the srcset into individual source strings
            const sources = srcset.split(',').map(s => s.trim());
  
            // Find the highest quality source
            const highestQualitySource = sources.reduce((highest, current) => {
              const [url, descriptor] = current.split(' ');
              const currentDensity = parseFloat(descriptor);
              const highestDensity = parseFloat(highest.split(' ')[1]);
              return currentDensity > highestDensity ? current : highest;
            });
  
            return highestQualitySource.split(' ')[0];
          } else {
            return firstImage.getAttribute('src');
          }
        }
        return '';
      }
  
      // Function to get the current price
      function getCurrentPrice() {
        const visibleElements = document.querySelectorAll('.product__info-wrapper .price__sale .price-item--sale');
        let priceElement = null;
        
        for (const element of visibleElements) {
          if (element.offsetParent !== null) { // Check if visible
            priceElement = element;
            break;
          }
        }
        
        if (!priceElement && visibleElements.length > 0) {
          priceElement = visibleElements[0];
        }
        
        return priceElement ? priceElement.textContent.trim() : '';
      }
  
      // Function to get the original price
      function getOriginalPrice() {
        const visibleElements = document.querySelectorAll('.product__info-wrapper .price__sale .price-item--regular');
        let originalPriceElement = null;
        
        for (const element of visibleElements) {
          if (element.offsetParent !== null) { // Check if visible
            originalPriceElement = element;
            break;
          }
        }
        
        if (!originalPriceElement && visibleElements.length > 0) {
          originalPriceElement = visibleElements[0];
        }
        
        return originalPriceElement ? originalPriceElement.textContent.trim() : '';
      }
  
      // Function to get the vendor
      function getVendor() {
        const visibleElements = document.querySelectorAll('.product__info-wrapper .product-vendor .custom-dealmed-vendor');
        let vendorElement = null;
        
        for (const element of visibleElements) {
          if (element.offsetParent !== null) { // Check if visible
            vendorElement = element;
            break;
          }
        }
        
        if (!vendorElement && visibleElements.length > 0) {
          vendorElement = visibleElements[0];
        }
        
        return vendorElement ? vendorElement.textContent.trim() : '';
      }
  
      // Function to get the reviews
      function getReviews() {
        const visibleElements = document.querySelectorAll('.product__info-wrapper [data-oke-star-rating]');
        let reviewsElement = null;
        
        for (const element of visibleElements) {
          if (element.offsetParent !== null) { // Check if visible
            reviewsElement = element;
            break;
          }
        }
        
        if (!reviewsElement && visibleElements.length > 0) {
          reviewsElement = visibleElements[0];
        }
        
        return reviewsElement ? reviewsElement.outerHTML : '';
      }
  
      // Function to update localStorage
      function updateProductViewHistory(newProduct) {
        let productViewHistory = JSON.parse(localStorage.getItem(STORAGE_KEY_PRODUCT) || '[]');
  
        // Remove this product if it already exists (comparing by URL)
        productViewHistory = productViewHistory.filter(product => product.url !== newProduct.url);
  
        // Add the new product to the beginning
        productViewHistory.unshift(newProduct);
  
        // Keep only the latest MAX_PRODUCTS_HISTORY items
        productViewHistory = productViewHistory.slice(0, MAX_PRODUCTS_HISTORY);
  
        // Save back to localStorage
        localStorage.setItem(STORAGE_KEY_PRODUCT, JSON.stringify(productViewHistory));
      }
  
      // Get the current product details
      const currentProductUrl = getCleanProductUrl();
      const currentProductTitle = getProductTitle();
      const currentProductImageUrl = getProductImageUrl();
      const currentPrice = getCurrentPrice();
      const originalPrice = getOriginalPrice();
      const vendor = getVendor();
      const reviews = getReviews();
  
      // Debug logging (remove in production)
      // console.log('Product data collected:', {
      //   url: currentProductUrl,
      //   title: currentProductTitle,
      //   vendor: vendor,
      //   currentPrice: currentPrice
      // });
  
      // If we have the necessary details, update the history
      if (currentProductUrl && currentProductTitle) {
        updateProductViewHistory({
          url: currentProductUrl,
          title: currentProductTitle,
          imageUrl: currentProductImageUrl,
          currentPrice: currentPrice,
          originalPrice: originalPrice,
          vendor: vendor,
          reviews: reviews
        });
      }
    }
  });
  
  // Scroll setup functionality
  document.addEventListener('DOMContentLoaded', function() {
    function setupScroll(config) {
        const wrapper = document.querySelector(config.wrapperSelector);
        const container = document.querySelector(config.containerSelector);
        const leftArrow = document.querySelector(config.leftArrowSelector);
        const rightArrow = document.querySelector(config.rightArrowSelector);
      
        if (wrapper && container && leftArrow && rightArrow) {
          let scrollAmount = window.innerWidth > 750 ? 700 : 300;
      
          function updateArrowVisibility() {
            const scrollLeft = container.scrollLeft;
            const scrollWidth = container.scrollWidth;
            const clientWidth = container.clientWidth;
      
            // Only show arrows if content overflows
            const needsScrolling = scrollWidth > clientWidth;
            
            if (!needsScrolling) {
              leftArrow.style.display = 'none';
              rightArrow.style.display = 'none';
              return;
            }
      
            leftArrow.style.display = scrollLeft > 5 ? 'flex' : 'none';
            rightArrow.style.display = scrollLeft < scrollWidth - clientWidth - 5 ? 'flex' : 'none';
          }
      
          // Remove event listeners properly without cloning
          leftArrow.onclick = null;
          rightArrow.onclick = null;
          
          leftArrow.onclick = function() {
            container.scrollLeft -= scrollAmount;
            setTimeout(updateArrowVisibility, 100);
          };
      
          rightArrow.onclick = function() {
            container.scrollLeft += scrollAmount;
            setTimeout(updateArrowVisibility, 100);
          };
      
          container.onscroll = updateArrowVisibility;
      
          // Initial check
          setTimeout(updateArrowVisibility, 100);
        }
    }
  
    function setupAllScrolls() {
      setupScroll({
        name: 'recentProducts',
        wrapperSelector: '.scrollable-outer-wrapper',
        containerSelector: '.scrollable_section',
        leftArrowSelector: '.left-arrow',
        rightArrowSelector: '.right-arrow'
      });
  
      setupScroll({
        name: 'algoliaProducts',
        wrapperSelector: '.aa-Source[data-autocomplete-source-id="products"]',
        containerSelector: '.aa-Source[data-autocomplete-source-id="products"] #autocomplete-0-products-list',
        leftArrowSelector: '.left-arrow-products',
        rightArrowSelector: '.right-arrow-products'
      });
  
      setupScroll({
        name: 'recentlySearched',
        wrapperSelector: '.aa-Source[data-autocomplete-source-id="recentsearchedwrapper"]',
        containerSelector: '.aa-Source[data-autocomplete-source-id="recentsearchedwrapper"] .aa-Source',
        leftArrowSelector: '.left-arrow-recent',
        rightArrowSelector: '.right-arrow-recent'
      });
    }
  
    // Flag to prevent recursive observer calls
    let isSettingUp = false;
  
    // Set up a MutationObserver to watch for changes in the DOM
    const observer1 = new MutationObserver(function(mutations) {
      if (isSettingUp) return; // Prevent recursive calls
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          // Check if any of our target elements have been added
          if (document.querySelector('.scrollable-outer-wrapper') ||
              document.querySelector('.aa-Source[data-autocomplete-source-id="products"]') ||
              document.querySelector('.aa-Source[data-autocomplete-source-id="recentsearchedwrapper"]')) {
            
            isSettingUp = true;
            setupAllScrolls();
            setTimeout(() => isSettingUp = false, 100); // Reset flag after setup
          }
        }
      });
    });
  
    // Start observing the document with the configured parameters
    observer1.observe(document.body, { childList: true, subtree: true });
  
    // Run setup when Algolia updates the results
    document.addEventListener('autocomplete:updated', function() {
      if (!isSettingUp) {
        isSettingUp = true;
        setupAllScrolls();
        setTimeout(() => isSettingUp = false, 100);
      }
    });
  
    // Run setup when the autocomplete opens
    document.addEventListener('autocomplete:opened', function() {
      if (!isSettingUp) {
        isSettingUp = true;
        setupAllScrolls();
        setTimeout(() => isSettingUp = false, 100);
      }
    });
  });
  
  // Clear recent searches
  document.addEventListener('click', function(e) {
    if (e.target.closest('.clear_recent_searches')) {
      e.preventDefault();
      // Clear localStorage item
      localStorage.removeItem('AUTOCOMPLETE_RECENT_SEARCHES');
  
      // Remove the recent-searched-wrapper div
      const recentSearchedWrapper = document.querySelector('.recent-searched-wrapper');
      if (recentSearchedWrapper) {
        recentSearchedWrapper.remove();
      }
  
      // Remove the parent of .aa-SourceHeader
      const clearButton = e.target.closest('.clear_recent_searches');
      const sourceHeader = clearButton.closest('.aa-SourceHeader');
      if (sourceHeader) {
        sourceHeader.remove();
      }
    }
  });
  
  // Clear recent products
  document.addEventListener('click', function(e) {
    if (e.target.closest('.clear_recent_products')) {
      e.preventDefault();
      // Clear localStorage item
      localStorage.removeItem('PRODUCT_VIEW_HISTORY');
  
      // Remove the recent-searched-wrapper div
      const recentProductsWrapper = document.querySelector('.recent-products-wrapper');
      if (recentProductsWrapper) {
        recentProductsWrapper.remove();
      }
  
      // Remove the parent of .aa-SourceHeader
      const clearButton = e.target.closest('.clear_recent_products');
      const recentProductsHeading = clearButton.closest('.recent-products-heading');
      if (recentProductsHeading) {
        recentProductsHeading.remove();
      }
    }
  });
  
  // Update suggested products text and links
  setInterval(() => {
    // Set "Suggested Products" text
    const sourceHeaderTitle = document.querySelector('.aa-Source[data-autocomplete-source-id=products] .aa-SourceHeaderTitle');
    if (sourceHeaderTitle) {
      sourceHeaderTitle.textContent = 'Suggested Products';
    }
  
    // Add "see all" link if it doesn't exist
    const sourceHeader = document.querySelector('.aa-Source[data-autocomplete-source-id=products] .aa-SourceHeader');
    if (sourceHeader && !sourceHeader.querySelector('a.see_all')) {
      const seeAllLink = document.createElement('a');
      seeAllLink.href = '';
      seeAllLink.className = 'see_all';
      seeAllLink.textContent = 'See All';
      
      const headerTitle = sourceHeader.querySelector('.aa-SourceHeaderTitle');
      if (headerTitle) {
        headerTitle.insertAdjacentElement('afterend', seeAllLink);
      }
    }
  
    // Extract count from parentheses
    const seeAllBtn = document.querySelector('.aa-SeeAllBtn');
    if (seeAllBtn) {
      const target = seeAllBtn.textContent;
      const count = target.match(/\(([^)]+)\)/);
      const countText = count ? count[1] : '';
  
      const seeAllLink = document.querySelector('.see_all');
      
      // Set text for both buttons
      if (countText) {
        const newText = 'Shop All (' + countText + ')';
        if (seeAllLink) {
          seeAllLink.textContent = newText;
        }
        seeAllBtn.textContent = newText;
      } else {
        if (seeAllLink) {
          seeAllLink.style.display = 'none';
        }
      }
      
      // Set URL and hide original button
      const url = seeAllBtn.getAttribute('href');
      if (seeAllLink && url) {
        seeAllLink.setAttribute('href', url);
      }
      seeAllBtn.style.display = 'none';
  
      // Click handler
      if (seeAllLink) {
        // Remove existing event listener by cloning
        const newSeeAllLink = seeAllLink.cloneNode(true);
        seeAllLink.parentNode.replaceChild(newSeeAllLink, seeAllLink);
        
        newSeeAllLink.addEventListener('click', (e) => {
          e.preventDefault();
          seeAllBtn.click();
        });
      }
    }
  }, 100);
  
  // Handle suggested product clicks
  document.addEventListener('click', function(e) {
    const suggestedItem = e.target.closest('.suggested_product_outer .aa-Item, .suggested_collection_outer .aa-Item');
    if (suggestedItem) {
      e.preventDefault();
      const searchInput = document.getElementById('autocomplete-0-input');
      const productLink = suggestedItem.querySelector('a.aa-ItemLink');
      
      if (searchInput && productLink) {
        const inputValue = searchInput.value;
        const productUrl = productLink.getAttribute('href');
        
        if (inputValue && productUrl) {
          const newSearch = {
            id: inputValue,
            label: inputValue
          };
          
          let recentSearches = JSON.parse(localStorage.getItem('AUTOCOMPLETE_RECENT_SEARCHES')) || [];
          const exists = recentSearches.some(function(search) {
            return search.id === inputValue;
          });
          
          if (!exists) {
            recentSearches.push(newSearch);
          }
          
          localStorage.setItem('AUTOCOMPLETE_RECENT_SEARCHES', JSON.stringify(recentSearches));
          window.location.href = productUrl;
        }
      }
    }
  });
  
  // Product suggestion scroller (IIFE)
  (function() {
    // Function to initialize the scroller
    function initializeScroller(sourceElement) {
      if (sourceElement.querySelector('.scrollable-product-outer-wrapper')) {
        return; // Scroller already initialized for this element
      }
  
      const outerWrapper = document.createElement('div');
      outerWrapper.className = 'suggested_product_outer scrollable-product-outer-wrapper';
  
      const leftArrow = createArrowButton('left-arrow-products');
      const rightArrow = createArrowButton('right-arrow-products');
  
      // Move the original content into the new wrapper
      outerWrapper.innerHTML = sourceElement.innerHTML;
      sourceElement.innerHTML = '';
  
      // Append the new structure
      sourceElement.appendChild(leftArrow);
      sourceElement.appendChild(outerWrapper);
      sourceElement.appendChild(rightArrow);
  
      // Setup scroll functionality
      setupScrolling(outerWrapper, leftArrow, rightArrow);
    }
  
    // Function to create arrow buttons
    function createArrowButton(className) {
      const button = document.createElement('button');
      button.className = `scroll-arrow ${className}`;
      button.style.display = 'none';
      button.innerHTML = `<span><svg class="" viewBox="0 0 100 100"><path d="M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z" class="arrow"${className.includes('right') ? ' transform="translate(100, 100) rotate(180) "' : ''}></path></svg></span>`;
      return button;
    }
  
    // Function to setup scrolling behavior
    function setupScrolling(wrapper, leftArrow, rightArrow) {
      const scrollStep = 200;
  
      leftArrow.addEventListener('click', () => {
        wrapper.scrollLeft -= scrollStep;
      });
  
      rightArrow.addEventListener('click', () => {
        wrapper.scrollLeft += scrollStep;
      });
  
      wrapper.addEventListener('scroll', () => {
        leftArrow.style.display = wrapper.scrollLeft > 0 ? 'flex' : 'none';
        rightArrow.style.display = wrapper.scrollLeft < (wrapper.scrollWidth - wrapper.clientWidth) ? 'flex' : 'none';
      });
  
      // Initial arrow visibility
      setTimeout(() => {
        rightArrow.style.display = wrapper.scrollWidth > wrapper.clientWidth ? 'flex' : 'none';
      }, 0);
    }
  
    // Function to start observing
    function startObserving() {
      const productSuggestionObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            const panelSections = document.querySelectorAll('.aa-PanelSection');
            panelSections.forEach(panelSection => {
              const sourceElement = panelSection.querySelector('.aa-Source[data-autocomplete-source-id="products"]');
              if (sourceElement) {
                initializeScroller(sourceElement);
              }
            });
          }
        }
      });
      // Start observing the document with the configured parameters
      productSuggestionObserver.observe(document.body, { childList: true, subtree: true });
    }
  
    // Wait for the DOM to be fully loaded before starting the observer
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving);
    } else {
      startObserving();
    }
  })();
  
  
  // Wait for element utility function
  function waitForElm(selector) {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }
  
      const observer = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  
  // Document ready functionality
  document.addEventListener('DOMContentLoaded', function() {
    // Clear button click handler
    document.addEventListener('click', function(e) {
      if (e.target.closest('.aa-ClearButton')) {
        const overlay = document.querySelector('.aa-DetachedOverlay');
        if (overlay) {
          overlay.remove();
        }
      }
    });
  
    // Keyup handler for autocomplete input
    document.addEventListener('keyup', async function(e) {
      if (e.target.id === 'autocomplete-0-input') {
        const searchValue = e.target.value;
        
        if (searchValue.length > 0) {
          await waitForElm('.aa-PanelSection--left');
          
          const leftPanel = document.querySelector('.aa-PanelSection--left');
          const rightPanel = document.querySelector('.aa-PanelSection--right');
          
          if (leftPanel && rightPanel) {
            if (leftPanel.children.length === 0) {
              rightPanel.style.flex = '1 0 100%';
            } else {
              leftPanel.style.display = 'block';
              leftPanel.style.flex = '1 0 25%';
              rightPanel.style.flex = '1 0 75%';
            }
          }
  
          setTimeout(async () => {
            await waitForElm('.aa-Source');
            
            // Process collections sources
            const sources = document.querySelectorAll('.aa-Source');
            sources.forEach(source => {
              const collectionId = source.dataset.autocompleteSourceId;
              
              if (collectionId === 'collections') {
                const items = source.querySelectorAll('.aa-List .aa-Item');
                items.forEach(item => {
                  if (item.querySelector('.no_image')) {
                    item.remove();
                  }
                });
              }
            });
  
            // Hide empty collections sources
            sources.forEach(source => {
              const collectionId = source.dataset.autocompleteSourceId;
              
              if (collectionId === 'collections') {
                const remainingItems = source.querySelectorAll('.aa-List .aa-Item');
                if (remainingItems.length === 0) {
                  source.style.display = 'none';
                } else {
                  source.style.display = 'block';
                }
              }
            });
          }, 500);
        }
      }
    });
  });
  
  // Input handler for autocomplete
  document.addEventListener('input', function(e) {
    if (e.target.id === 'autocomplete-0-input') {
      const panelSection = document.querySelector('.aa-PanelSection--left');
      console.log('Input event triggered');
  
      if (panelSection) {
        const panelContent = panelSection.innerHTML.trim();
        
        if (panelContent === '') {
          console.log('Panel is empty, hiding it');
          panelSection.style.display = 'none';
        } else {
          console.log('Panel is not empty, showing it');
          panelSection.style.display = 'block';
        }
      }
    }
  });
  
  // Customization after 18/07/2024
  // Function to create and show the overlay
  function showOverlay() {
    if (!document.querySelector('.overlay-box')) {
      const overlay = document.createElement('div');
      overlay.className = 'overlay-box';
      document.body.appendChild(overlay);
      setTimeout(() => overlay.style.display = 'block', 0);
    }
  }
  
  // Function to create and show the header overlay
  function showHeaderOverlays() {
    const headerContainers = [
      { selector: '.header', class: 'site-header-overlay' },
      { selector: '.utility-bar', class: 'site-header-overlay' }
    //   { selector: '.header__inline-menu', class: 'menu-header-overlay' }
    ];
  
    headerContainers.forEach(container => {
      let headerElement;
      if (container.id) {
        headerElement = document.getElementById(container.id);
      } else if (container.selector) {
        headerElement = document.querySelector(container.selector);
      }
  
      if (headerElement && !headerElement.querySelector(`.${container.class}`)) {
        const overlay = document.createElement('div');
        overlay.className = `header-overlay ${container.class}`;
        headerElement.appendChild(overlay);
        setTimeout(() => overlay.style.display = 'block', 0);
      }
    });
    
    const liveSearchCustom = document.querySelector('.live-search-custom');
    if (liveSearchCustom) {
      liveSearchCustom.classList.add('search-wrap-full');
    }
    
    if (window.innerWidth > 749) {
      document.documentElement.style.overflow = 'hidden';
    }
    
    const shopifyHeader = document.querySelector('.shopify-header');
    if (shopifyHeader) {
      shopifyHeader.classList.add('show_overlay');
    }
  }
  
  // Function to remove the overlay
  function removeOverlay() {
    const overlay = document.querySelector('.overlay-box');
    if (overlay) {
      overlay.remove();
      
      const liveSearchCustom = document.querySelector('.live-search-custom');
      if (liveSearchCustom) {
        liveSearchCustom.classList.remove('search-wrap-full');
      }
      
      document.documentElement.style.overflow = 'unset';
    }
  }
  
  // Function to remove all header overlays
  function removeHeaderOverlays() {
    const overlays = document.querySelectorAll('.header-overlay');
    overlays.forEach(overlay => overlay.remove());
    
    const shopifyHeader = document.querySelector('.shopify-header');
    if (shopifyHeader) {
      shopifyHeader.classList.remove('show_overlay');
    }
  }
  
  // Function to initialize the MutationObserver
  function initializeObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Check for added nodes
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('aa-Panel')) {
              showOverlay();
              showHeaderOverlays();
            }
          });
  
          // Check for removed nodes
          mutation.removedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('aa-Panel')) {
              removeOverlay();
              removeHeaderOverlays();
            }
          });
        }
      });
    });
  
    // Start observing the document body for changes
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      console.error('Document body not found. Make sure the script runs after the body is loaded.');
    }
  }
  
  // Call the initialization function when the DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeObserver);
  } else {
    initializeObserver();
  }
  
  // Mobile Search close on clicking outside
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      // Check if aa-DetachedOverlay exists
      const detachedOverlay = document.querySelector('.aa-DetachedOverlay');
      if (detachedOverlay) {
        const target = event.target;
  
        // Check if the click is outside of aa-DetachedFormContainer, aa-Panel, and aa-DetachedSearchBox
        if (!target.closest('.aa-DetachedFormContainer') &&
            !target.closest('.aa-Panel') &&
            !target.closest('.aa-DetachedSearchButton')) {
  
          // Trigger the click event on the cancel button
          const cancelButton = document.querySelector('.aa-DetachedCancelButton');
          if (cancelButton) {
            cancelButton.click();
          }
        }
      }
    });
  
    // Prevent the event from propagating when clicking inside specific elements
    document.addEventListener('click', function(event) {
      if (event.target.closest('.aa-DetachedFormContainer') ||
          event.target.closest('.aa-Panel') ||
          event.target.closest('.aa-DetachedSearchButton')) {
        event.stopPropagation();
      }
    });
  
  });